import { useQuery, type UseQueryResult } from '@tanstack/react-query';

import { fetchMyParty } from '../api/client.js';
import { MY_PARTY_QUERY_KEY } from '../api/queryKeys.js';

import type { MyPartyResponse } from '@mixwire/contracts';

export const useMyParty = (isEnabled: boolean): UseQueryResult<MyPartyResponse> =>
  useQuery({
    queryKey: MY_PARTY_QUERY_KEY,
    queryFn: fetchMyParty,
    enabled: isEnabled,
    staleTime: 15_000,
  });
